import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { HeartPulse, Bell, LogOut, User } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/Button';

export default function PatientLayout() {
    const { user, logout } = useAuth();

    return (
        <div className="min-h-screen bg-slate-50 font-inter">
            {/* Top Navbar */}
            <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-md border-b border-slate-100 shadow-soft print:hidden h-20 flex items-center">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex items-center justify-between">
                    <Link to="/patient" className="flex items-center gap-3">
                        <div className="h-10 w-10 rounded-xl bg-brand-600 flex items-center justify-center text-white shadow-premium shrink-0">
                            <HeartPulse className="h-6 w-6" />
                        </div>
                        <div className="flex flex-col">
                            <span className="text-xl font-black tracking-tight text-slate-900 font-outfit uppercase leading-none">P2G Life</span>
                            <span className="text-[10px] font-black text-brand-600 uppercase tracking-widest mt-1">Patient Portal</span>
                        </div>
                    </Link>

                    <div className="flex items-center gap-6">
                        <Button variant="ghost" size="icon" className="relative text-slate-400 hover:text-brand-600 transition-colors">
                            <Bell className="h-5 w-5" />
                            <span className="absolute top-2.5 right-2.5 h-2 w-2 rounded-full bg-brand-500 ring-2 ring-white"></span>
                        </Button>

                        <div className="flex items-center gap-4 pl-6 border-l border-slate-100">
                            <div className="text-right hidden sm:block">
                                <p className="text-sm font-black text-slate-900 leading-tight">{user?.name}</p>
                                <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Active Profile</p>
                            </div>
                            <div className="h-10 w-10 rounded-2xl bg-gradient-to-br from-brand-500 to-brand-700 flex items-center justify-center text-white font-black shadow-md">
                                {user?.name?.charAt(0) || 'P'}
                            </div>
                            <Button variant="ghost" size="icon" onClick={logout} className="h-9 w-9 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-xl transition-all" title="Sign Out">
                                <LogOut className="h-4 w-4" />
                            </Button>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 print:p-0 print:m-0 print:max-w-none print:w-full">
                <Outlet />
            </main>
        </div>
    );
}
